import React from 'react';
import domainFromUrl from '../util/domain-from-url';
import { getEngagementRateBadge } from '../util/engagement-rate-badge';

const formatCompactMetric = value => {
    const num = Number(value);
    if (!Number.isFinite(num) || num < 0) return null;
    if (num >= 1_000_000) {
        const formatted = (num / 1_000_000).toFixed(1);
        return `${formatted.endsWith('.0') ? formatted.slice(0, -2) : formatted}M`;
    }
    if (num >= 1_000) {
        const formatted = (num / 1_000).toFixed(1);
        return `${formatted.endsWith('.0') ? formatted.slice(0, -2) : formatted}K`;
    }
    return String(num);
};

export default function UrlPreviewSource({ metaData, color = 'rgba(255, 255, 255, 0.6)' }) {
    const label = metaData?.publisher || domainFromUrl(metaData?.url) || '';
    if (!label && !metaData?.logo) return null;
    const metrics = metaData?.sourceMetrics;
    const hasMetrics = metrics && (metrics.viewCount || metrics.likeCount || metrics.commentCount);
    const erBadge = getEngagementRateBadge(metrics?.engagementRate, color);

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, flex: 1, minWidth: 0, marginRight: 10, color, fontSize: 13, flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: 0, overflow: 'hidden' }}>
                {metaData?.logo ? (
                    <img src={metaData.logo} alt={label} referrerPolicy="no-referrer"
                        style={{ height: 16, width: 16, objectFit: 'contain', flexShrink: 0 }} />
                ) : null}
                <span title={label} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>
                    {label}
                </span>
            </div>
            {hasMetrics ? (
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11, opacity: 0.85, marginLeft: 'auto', flexShrink: 0 }}>
                    {metrics.viewCount ? <span title={`${metrics.viewCount.toLocaleString()} views`}>👁 {formatCompactMetric(metrics.viewCount)}</span> : null}
                    {metrics.likeCount ? <span title={`${metrics.likeCount.toLocaleString()} likes`}>❤️ {formatCompactMetric(metrics.likeCount)}</span> : null}
                    {metrics.commentCount ? <span title={`${metrics.commentCount.toLocaleString()} comments`}>💬 {formatCompactMetric(metrics.commentCount)}</span> : null}
                    {erBadge ? (
                        <span
                            style={{
                                padding: '1px 5px',
                                borderRadius: 4,
                                fontSize: 10,
                                fontWeight: 600,
                                backgroundColor: erBadge.backgroundColor,
                                color: erBadge.color
                            }}
                            title={erBadge.title}
                        >
                            {erBadge.icon ? `${erBadge.icon} ` : ''}
                            {erBadge.label}
                        </span>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
}
